import script from "./SiteMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SiteMenu.vue?vue&type=style&index=0&id=2e9e47c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9e47c8"]])

export default __exports__